/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { addresses_CreateAddressRequest } from '../models/addresses_CreateAddressRequest';
import type { models_Address } from '../models/models_Address';
import type { models_AddressUsageResponse } from '../models/models_AddressUsageResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AddressesService {
    /**
     * List addresses
     * List addresses with pagination, optionally filtered by a full-text search term
     * @param limit Limit
     * @param offset Offset
     * @param search Search term matched against street, house number, info line, zip, city, and country
     * @returns models_Address OK
     * @throws ApiError
     */
    public static getApiV1Addresses(
        limit: number = 10,
        offset?: number,
        search?: string,
    ): CancelablePromise<Array<models_Address>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/addresses',
            query: {
                'limit': limit,
                'offset': offset,
                'search': search,
            },
            errors: {
                500: `Failed to list addresses`,
            },
        });
    }
    /**
     * Create an address
     * Create a new address
     * @param address Address data
     * @returns models_Address Created
     * @throws ApiError
     */
    public static postApiV1Addresses(
        address: addresses_CreateAddressRequest,
    ): CancelablePromise<models_Address> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/addresses',
            body: address,
            errors: {
                400: `Validation errors or invalid request format`,
                500: `Failed to create address`,
            },
        });
    }
    /**
     * Delete an address
     * Soft-delete an address
     * @param id Address ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Addresses(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/addresses/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing address ID`,
                404: `Address not found`,
                500: `Failed to delete address`,
            },
        });
    }
    /**
     * Get an address by ID
     * Get an address by ID
     * @param id Address ID
     * @returns models_Address OK
     * @throws ApiError
     */
    public static getApiV1Addresses1(
        id: string,
    ): CancelablePromise<models_Address> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/addresses/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing address ID`,
                404: `Address not found`,
                500: `Failed to get address`,
            },
        });
    }
    /**
     * Get address usage information
     * Get count and details of entities using this address
     * @param id Address ID
     * @returns models_AddressUsageResponse OK
     * @throws ApiError
     */
    public static getApiV1AddressesUsage(
        id: string,
    ): CancelablePromise<models_AddressUsageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/addresses/{id}/usage',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing address ID`,
                404: `Address not found`,
                500: `Failed to get address usage`,
            },
        });
    }
    /**
     * Search addresses by city
     * Search addresses by city name
     * @param city City name
     * @param limit Limit
     * @param offset Offset
     * @returns models_Address OK
     * @throws ApiError
     */
    public static getApiV1AddressesSearch(
        city: string,
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<models_Address>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/addresses/search',
            query: {
                'city': city,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Missing city parameter`,
                500: `Failed to search addresses`,
            },
        });
    }
}
